import Vuex from "vuex";
import VuexPersistence from "vuex-persist";


import auth from "@/store/modules/auth";
import users from "@/store/modules/users";
import delete_user from "@/store/modules/delete";
import userDetails from "@/store/modules/user/details";
import reports from "@/store/modules/reports";
import reportsDetails from "@/store/modules/reports/details";
import sightings from "@/store/modules/sightings";
import sightingsDetails from "@/store/modules/sightings/details";
import sightingsImport from "@/store/modules/sightings/importData";
import sightingsExport from "@/store/modules/sightings/exportData";
import sightingsWhale from "@/store/modules/sightings/whale";
import whales from "@/store/modules/whales";
import whalesDetails from "@/store/modules/whales/details"
import whalesView from "@/store/modules/whales/view"
import images from "@/store/modules/images";
import imageSearch from "@/store/modules/imageSearch";

import vuexLocal from "@/plugins/vue-persist";
import dashboard from "@/store/modules/dashboard";
import analytics from "@/store/modules/analytics";
import quality from "@/store/modules/qa";
import audit from "@/store/modules/audit";
import reportDashboard from "@/store/modules/reportDashboard";
import reset from "@/store/modules/reset";


const store = new Vuex.Store({
  modules: {
    auth: auth,
    reset: reset,
    users: users,
    delete: delete_user,
    report: {
      namespaced: true,
      modules: {
        details: reportsDetails,
      },
    },
    sighting: {
      namespaced: true,
      modules: {
        details: sightingsDetails,
        import: sightingsImport,
        export: sightingsExport,
        whale: sightingsWhale
      },
    },
    whale: {
      namespaced: true,
      modules: {
        details: whalesDetails,
        view: whalesView,
      }
    },
    user: {
      namespaced: true,
      modules: {
        details: userDetails,
      },
    },
    reports: reports,
    sightings: sightings,
    whales: whales,
    dashboard: dashboard,
    analytics: analytics,
    quality: quality,
    audit: audit,
    reportDashboard: reportDashboard,
    images: images,
    imageSearch: imageSearch
  },
  plugins: [vuexLocal.plugin, new VuexPersistence().plugin],
});

export default store;
